import api from "../services/api";

export interface ExpenseCategoryDTO {
  id: string;
  name: string;
  createdAt: string;
  expenseCount: number;
}

export interface TournamentExpenseDTO {
  id: string;
  tournamentId: string;
  categoryId: string;
  categoryName: string;
  amount: number;
  description: string | null;
  expenseDate: string;
  createdAt: string;
  updatedAt: string;
  createdByName: string | null;
}

export const getExpenseCategories = (): Promise<{ data: ExpenseCategoryDTO[] }> =>
  api.get("ExpenseCategory");

export const createExpenseCategory = (data: { name: string }) =>
  api.post("ExpenseCategory", data);

export const updateExpenseCategory = (id: string, data: { name?: string }) =>
  api.put(`ExpenseCategory/${id}`, data);

export const deleteExpenseCategory = (id: string) =>
  api.delete(`ExpenseCategory/${id}`);

export const getTournamentExpenses = (tournamentId: string): Promise<{ data: TournamentExpenseDTO[] }> =>
  api.get(`tournament/${tournamentId}/expenses`);

export const createTournamentExpense = (
  tournamentId: string,
  data: {
    categoryId: string;
    amount: number;
    description?: string;
    status?: string;
    paymentMethod?: string;
    expenseDate?: string;
  },
) => api.post(`tournament/${tournamentId}/expenses`, data);

export const updateTournamentExpense = (
  tournamentId: string,
  expenseId: string,
  data: {
    categoryId?: string;
    amount?: number;
    description?: string;
    status?: string;
    paymentMethod?: string;
    expenseDate?: string;
  },
) => api.put(`tournament/${tournamentId}/expenses/${expenseId}`, data);

export const deleteTournamentExpense = (tournamentId: string, expenseId: string) =>
  api.delete(`tournament/${tournamentId}/expenses/${expenseId}`);
